import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemOms} from '../OM/FormChooseOm.jsx'
import Model from './ModelOo.mjs'

export const FormItemOoName = props => (
    <FormItemBizProp
        Model={Model}
        prop="ooName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemOoNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="ooNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseOo(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemOms />
            <FormItemOoNo />
            <FormItemOoName />
        </FormChooseExternal>
    )
}
